export default __webpack_public_path__ + "static/media/nouns_stamp.8360f622.svg";